let slider;
let tns;

window.silesia = window.silesia || {};
window.silesia.layout = window.silesia.layout || {};

window.silesia.layout.tabs = function(config) {
    return {
        currentTab:null,
        config:config||{},

        init:function() {
        },
    
        load:function() {
            var self =this;
            Array.from(this.$el.querySelectorAll('.wp-block-silesia-core-tabs-labels > li')).forEach((el,i) => {
                el.dataset.tabId = el.dataset.tabId || 'tab-id-'+i;
                if(self.currentTab===null) {
                    self.currentTab = el.dataset.tabId;
                }
                el.setAttribute('x-on:click','currentTab=$el.dataset.tabId');
                el.setAttribute('x-bind:class','{\'is-active\':(currentTab==$el.dataset.tabId)}');
            });
            Array.from(this.$el.querySelectorAll('.wp-block-silesia-core-tabs-tabs > .wp-block-silesia-core-tabs-item')).forEach((el,i) => {
                el.dataset.tabId = el.dataset.tabId || 'tab-id-'+i;
                el.setAttribute('x-bind:class','{\'is-active\':(currentTab==$el.dataset.tabId)}');
                el.toggleAttribute('x-transition',true);
            });
        }
    }
}



if(document.querySelector('*[x-data-lazy*="window.silesia.layout.tabs"]')) {
    for(var el of document.querySelectorAll('*[x-data-lazy*="window.silesia.layout.tabs"]')) {
        el.setAttribute('x-init', 'load')
        el.setAttribute('x-data', el.getAttribute('x-data-lazy'))
        el.removeAttribute('x-data-lazy');
    };
}

